module.exports = __webpack_public_path__ + "img/fantasy.981caf6c.svg";